var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39608 1.14441e-05C11.4907 1.14441e-05 14.8106 3.31995 14.8106 7.39609C14.8106 11.4907 11.4907 14.8106 7.39608 14.8106C3.31993 14.8106 0 11.4907 0 7.39609C0 3.31995 3.31993 1.14441e-05 7.39608 1.14441e-05ZM7.39608 6.36322L9.86758 3.91016L10.9005 4.94302L8.44739 7.39609L10.9005 9.86759L9.86758 10.9005L7.39608 8.4474L4.94301 10.9005L3.91014 9.86759L6.36321 7.39609L3.91014 4.94302L4.94301 3.91016L7.39608 6.36322Z",
    fill: "#F97E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.122725eb993f34b7cb5b7292a77d7ca0.svg";
export { ForwardRef as ReactComponent };